// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__OJ3TF","modalForm":"UpgradeEpcsModal_modalForm__2wQk9","modalFooter":"UpgradeEpcsModal_modalFooter__1HAww"};